import { render, staticRenderFns } from "./AdminPaisesComponent.vue?vue&type=template&id=0dc6982d&scoped=true"
import script from "./AdminPaisesComponent.vue?vue&type=script&lang=ts"
export * from "./AdminPaisesComponent.vue?vue&type=script&lang=ts"
import style0 from "./AdminPaisesComponent.vue?vue&type=style&index=0&id=0dc6982d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6982d",
  null
  
)

export default component.exports